import axios from 'axios';
import { allow } from '../classes/allow';
import is from '../objects/is';
import the from '../objects/the';
import use from '../objects/use';

export default function useAxios() {
    const tracker = use.inflightTracker!;


    const call = async (method: any = the.method.get, url = '', data = {}, headers = {}) => {
        allow.oneOf(method, the.method).aString(url, is.not.empty).anObject(data).anObject(headers);
        if (tracker.isAlreadyInflight(url))
            return;
        tracker.addApiCall(url);
        let response;
        if (method === the.method.get) {
            response = await axios({
                headers,
                method,
                params: data,
                url,
            }).catch(error => {
                tracker.removeApiCall(url);
                if (error.response)
                    return Promise.resolve(error.response);
                console.error(error);
            });
        } else if (method === the.method.post) {
            response = await axios({
                data,
                headers,
                method,
                url,
            }).catch(error => {
                tracker.removeApiCall(url);
                if (error.response)
                    return Promise.resolve(error.response);
                console.error(error);
            });
        }
        tracker.removeApiCall(url);
        return response;
    };

    return {
        call,
    };
}
